import { createReducer, on, select } from '@ngrx/store';
import {
  loadAllPartners,loadAllPartnersSuccess,loadAllPartnersFailure,
  loadPartners, loadPartnersSuccess, loadPartnersFailure,
  loadPartner, loadPartnerSuccess, loadPartnerFailure,
  addLocation, addLocationSuccess, addLocationFailure,
  createPartner, createPartnerSuccess, createPartnerFailure, updatePartner, updateLocation, loadLocations,
  locationsLoaded, loadLocationsFailure, loadCategories, loadCategoriesSuccess, loadCategoriesFailure, searchPartnersSuccess,
  clearPartnerDetails, selectPartner
 } from '../actions/partners.action';
 import * as partnerActions from '../../../../core/partners/store/actions/partners.action'
import { PartnerState } from '../../models/partners-state.model';

export const initialState: PartnerState = {
  ids: [],
  entities: {},
  partners: [],
  selectedPartnerId: null,
  selectPartner: null,
  selectedPartnerDetailsId: null,
  loading: false,
  error: null,
  locations: [],
  categories: [],
  partner: null,
  page: 1,
  totalItems: 0,
  totalPages: 0,
  searchedPartners: [],
};

export const partnerReducer = createReducer(
  initialState,
  on(partnerActions.loadAllPartners, (state) => {
    return { ...state, loading: true };
  }),
  on(partnerActions.loadAllPartnersSuccess, (state, { partners }) => {
    return {
      ...state,
      partners: partners.items,
      page: partners.page,
      totalItems: partners.total_items,
      totalPages: partners.total_pages,
      loading: false
    };
  }),
  on(partnerActions.loadAllPartnersFailure, (state, { error }) => {
    return {
      ...state,
      error,
      loading: false
    };
  }),

  on(partnerActions.searchPartnersSuccess, (state, { partners }) => {
    return {
      ...state,
      searchedPartners: partners.items, // Actualiza el estado con los socios buscados
      page: partners.page,
      totalItems: partners.total_items,
      totalPages: partners.total_pages
    };
  }),

  on(partnerActions.selectPartner, (state, action) => {
    return {
      ...state,
      isLoading: true, 
      selectPartnerId: action.partner_id, // Actualiza el estado con el socio seleccionado
    };
  }),

  on(partnerActions.selectPartnerSuccess, (state, action) => {
    return {
      ...state,
      isLoading: false,
      selectPartner: action.partner, // Actualiza el estado con el socio seleccionado
    };
  }),

  on(partnerActions.selectPartnerFailure, (state, { error }) => { 
    return {
      ...state,
      error,
      isLoading: false
    };
  }),

  on(partnerActions.updatePartner, (state, action) => ({
    ...state,
    partner: action.partner, 
  })),
  on(partnerActions.createPartner, (state) => ({
    ...state,
    isLoading: true, 
  })),
  on(partnerActions.createPartnerSuccess, (state, action) => ({
    ...state,
    partner: action.partner,
    isLoading: false, 
  })),
  on(partnerActions.createPartnerFailure, (state, action) => ({
    ...state,
    error: action.error, 
    isLoading: false,
  })),
  on(partnerActions.loadPartner, (state, { id }) => ({ 
    ...state, 
    selectedPartnerId: id, 
    loading: true 
  })),
  on(partnerActions.loadPartnerSuccess, (state, { partnerDetails }) => ({ 
    ...state, 
    entities: { ...state.entities, [partnerDetails.id]: partnerDetails }, 
    loading: false 
  })),
  on(partnerActions.loadPartnerFailure, (state, { error }) => ({ 
    ...state, 
    loading: false })),
  on(partnerActions.addLocation, (state) => {
    return { 
      ...state, 
      loading: true 
    };
  }),
on(partnerActions.addLocationSuccess, (state, { location }) => {
 
  return {
    ...state,
    loading: false,
    locations: [...state.locations, location]
  };  
}),
on(partnerActions.addLocationFailure, (state, { error }) => {
  return {
    ...state,
    loading: false,
    error: error
  };
}),

on(partnerActions.updateLocation, (state, action) => ({
  ...state,
  location: action.location,
})),

on(partnerActions.disablePartner, (state, { id }) => {
  return { ...state, loading: true };
}),
on(partnerActions.disablePartnerSuccess, (state, { partner }) => {
  return {
    ...state,
    loading: false,
    partners: state.partners.map(p => p.id === partner.id ? partner : p)
  };
}),
on(partnerActions.disablePartnerFailure, (state, { error }) => {
  return {
    ...state,
    error,
    loading: false
  };
}),

on(partnerActions.uploadLocations, (state, { locations }) => {
  return {
    ...state,
    locations: locations
  };
}),


on(partnerActions.loadCategories, state => state),
on(partnerActions.loadCategoriesSuccess, (state, { categories }) => ({ ...state, categories })),
on(partnerActions.loadCategoriesFailure, (state, { error }) => state),

on(partnerActions.clearPartnerDetails, (state) => ({
  ...state,
  selectedPartnerId: null,
  selectedPartnerDetailsId: null,
  partner: null,
  locations: [],
  categories: [],
  error: null
})),

);

